import {createFileRoute, redirect} from '@tanstack/react-router';

import {Route as RouteEnum} from '~utils/routeUtil';

export const Route = createFileRoute('/model/')({
  beforeLoad: async () => {
    // Redirect to model samples page
    throw redirect({
      to: RouteEnum.modelSamples as any,
    });
  },
});
